import { render, staticRenderFns } from "./ReviewProductFormModal.vue?vue&type=template&id=eddc20fc"
import script from "./ReviewProductFormModal.ts?vue&type=script&lang=ts&external"
export * from "./ReviewProductFormModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eddc20fc')) {
      api.createRecord('eddc20fc', component.options)
    } else {
      api.reload('eddc20fc', component.options)
    }
    module.hot.accept("./ReviewProductFormModal.vue?vue&type=template&id=eddc20fc", function () {
      api.rerender('eddc20fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/ReviewProductFormModal.vue"
export default component.exports